import { ScrollView } from 'react-native';
import { Redirect } from 'expo-router';
import { useLeagueContext } from '@/contexts/LeagueContext';
import MarchMadnessLeagueView from '@/components/MarchMadnessLeagueView';
import AppHeader from '@/components/AppHeader';
import NativeTabFocusGate from '@/components/navigation/NativeTabFocusGate';
import { Box } from '@/components/ui/primitives';
import { getLandingHref } from '@/lib/routes';
import { leagueRouteStyles } from '@/components/route/leagueRouteStyles';

export default function LeagueStandingsRoute() {
  const context = useLeagueContext();
  const id = context.id;

  if (!id || id === 'undefined') {
    return <Redirect href={getLandingHref()} />;
  }

  const { league, resolvedSeasonId } = context;

  const headerTitle = league?.name ?? 'League';

  return (
    <NativeTabFocusGate>
      <Box flex={1} backgroundColor="background">
        <AppHeader title={headerTitle} currentLeagueId={id} allowBack={false} />
        {context.isMarchMadness ? (
          <Box flex={1}>
            <MarchMadnessLeagueView
              leagueId={id}
              seasonId={resolvedSeasonId || ''}
              section="standings"
              currentUserId={context.league?.currentUserId}
              permissions={context.permissions}
            />
          </Box>
        ) : (
          <ScrollView style={leagueRouteStyles.flex} contentContainerStyle={leagueRouteStyles.content}>
            {/* Standard leaderboard would go here or MarchMadnessLeagueView handles it? */}
            {/* Wait, MarchMadnessLeagueView might be used for all standings in some cases? */}
            {/* Re-checking MarchMadnessLeagueView imports */}
            <MarchMadnessLeagueView
              leagueId={id}
              seasonId={resolvedSeasonId || ''}
              section="standings"
              currentUserId={context.league?.currentUserId}
              permissions={context.permissions}
            />
          </ScrollView>
        )}
      </Box>
    </NativeTabFocusGate>
  );
}
